export const headerHeight = 75;
export const maxContentWidth = 1200;
